import axios from "axios";
import { http } from "../http";

export const createLead = (data: any) => {
    return http.post("/kolla", data);
}

export const getBlogs = async () => {
    const url = "https://blog.dprprop.com/clients/683aacf141f4c4217e6d4d83/blogs";
    const response = await axios.get(url, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
        },
    });
    return response.data.data || response.data;
}

// Fetch details for a single blog by slug
export const getBlogDetails = async (slug: string) => {
    const url = `https://blog.dprprop.com/blogs/${slug}`;
    const response = await axios.get(url, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
        },
    });
    return response.data;
}